var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7037 19.8226C11.7037 20.2845 11.3293 20.6589 10.8674 20.6589C10.4056 20.6589 10.0312 20.2845 10.0312 19.8226V15.1515L2.53869 22.644C2.21211 22.9705 1.68262 22.9705 1.35604 22.644C1.02947 22.3174 1.02947 21.7879 1.35604 21.4613L8.84854 13.9688H4.17739C3.71554 13.9688 3.34114 13.5944 3.34114 13.1326C3.34114 12.6707 3.71554 12.2963 4.17739 12.2963H10.8674L10.889 12.2966C11.3409 12.308 11.7037 12.6779 11.7037 13.1326V19.8226Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3256 12C22.3256 6.29733 17.7026 1.67442 12 1.67442C6.29733 1.67442 1.67442 6.29733 1.67442 12C1.67442 12.4624 1.29959 12.8372 0.837209 12.8372C0.374831 12.8372 0 12.4624 0 12C5.66441e-06 5.37257 5.37257 5.66147e-06 12 0C18.6273 0 24 5.37257 24 12C24 18.6273 18.6273 24 12 24C11.5376 24 11.1628 23.6252 11.1628 23.1628C11.1628 22.7004 11.5376 22.3256 12 22.3256C17.7026 22.3256 22.3256 17.7026 22.3256 12Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircle);
export default __webpack_public_path__ + "static/media/arrow-circle.c0ac6acd4479cc4e5a519c8a48585fef.svg";
export { ForwardRef as ReactComponent };